import { PropTypes } from "prop-types";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./ReviewPolicy.scss";

const ReviewPolicy = ({ browseLanguage }) => {
  const { getTranslation } = useRuntimeConstants();

  const regionCode = browseLanguage.split("-")[1].toLowerCase();
  const urlLangParam = regionCode === "gb" ? "" : `${regionCode}/`;

  return (
    <div
      className={styles.reviewPolicyBody}
      dangerouslySetInnerHTML={{
        __html: getTranslation(
          "pdp_ratings_reviews_more_information_body",
        ).replace(
          "%{link}",
          `https://www.asos.com/${urlLangParam}discover/reviews`,
        ),
      }}
      data-testid="review-policy-content"
    />
  );
};

export default ReviewPolicy;

ReviewPolicy.propTypes = {
  browseLanguage: PropTypes.string.isRequired,
};
